module.exports = __webpack_public_path__ + "img/all_attack.1cf6b318.svg";